export class User {
    UserName: string;
    Password: string;
    FirstName: string;
    LastName: string;
    Email: string;
    PhoneNumber: string;
    RoleId: number;
    Active: boolean;
    ProviderId: string;
    SessionTokenKey: string;
    CountryId: number;
    IsLocked: boolean;
    LogCount: number;
    FirstQuestion: string;
    FirstAnswer: string;
    SecondQuestion: string;
    SecondAnswer: string;
}

export class AuthenticationResponse {
    RESPONSE_CODE: string;
    RESPONSE_DESC: string;
    UserID: string;
    SessionTokenKey: string;
}

export class CreateUserResponse {
    UserID: number;
    RESPONSE_CODE: string;
    RESPONSE_DESC: string;
}

export class Question {
    FirstQuestion: string;
    SecondQuestion: string;
}